import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TestIdDirective } from '@design/core/test-id.directive';
import { PhosphorIconComponent } from '@cintra-payroll-hr/components';
import { HelpLinkType, HelpLinksService } from '@app/help-links/help-links.service';

@Component({
  selector: 'app-authenticator-app-mfa-help',
  templateUrl: './authenticator-app-mfa-help.component.html',
  styleUrl: './authenticator-app-mfa-help.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TestIdDirective, PhosphorIconComponent]
})
export class AuthenticatorAppMfaHelpComponent {
  protected readonly helpLinks = inject(HelpLinksService);
  protected readonly HelpLinkType = HelpLinkType;

  expanded = signal<boolean>(false);

  protected onToggle(): void {
    this.expanded.set(!this.expanded());
  }

  protected onToggleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onToggle();
    }
  }
}
